import './css/style.scss';
import './i18n/i18n';

import { b2x } from '@b2x/react/src';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import { Button, ButtonVariant } from './Button';
import { CartSku } from './CartSku';
import { Container } from './Container';
import { en } from './i18n/locales/en';
import { it } from './i18n/locales/it';
import { IconName, IconSize } from './Icon';
import { ThemeColor } from './pages/TemplatePage';
import { ProductTile, ProductTileBasicInfo, ProductTileExtraInfo } from './ProductTile';
import { reportWebVitals } from './reportWebVitals';

b2x.init<ThemeColor, ButtonVariant, IconName, IconSize>({
  analytics: {
    facebook: {
      debug: true,
      sendPageView: true,
    },
  },
  api: {
    apiKey: 'HIEFHHCAABHFEGEHHDAJBA',
    productPopulate: {
      alternativeImages: true,
      attributes: true,
      brand: true,
      priceRange: true,
      reviews: true,
      skus: {
        alternativeImages: true,
        attributes: true,
        price: true,
      },
      variantProducts: {
        attributes: true,
        skus: true,
      },
    },
    productTilePopulate: {
      alternativeImages: true,
      attributes: true,
      brand: true,
      priceRange: true,
      skus: {
        alternativeImages: true,
        attributes: true,
        price: true,
      },
      variantProducts: {
        attributes: true,
      },
    },
    sessionOptions: {
      populate: {
        cart: {
          packs: {
            cartSkus: {
              sku: {
                product: true,
              },
            },
          },
          shippingProfile: true,
        },
        customer: true,
        wishlist: { products: false, skus: { product: false } },
      },
    },
  },
  defaultButtonVariant: 'primary',
  displayRadioConsents: true,
  enableCientSideComingSoonManagement: true,
  form: {
    buttons: {
      cancel: {
        defaultVariant: 'outline-primary',
      },
      submit: {
        defaultVariant: 'primary',
      },
    },
    explainMandatoryFields: true,
    showPlaceholder: true,
  },
  i18n: {
    en: en,
    it: it,
  },
  icons: {
    arrow: {
      bottom: 'arrow-down',
      left: 'arrow-left',
      right: 'arrow-right',
      top: 'arrow-up',
    },
    cart: 'cart',
    close: 'close',
    configurator: 'settings',
    download: 'account',
    info: 'info',
    logout: 'logout',
    passwordToggle: {
      hidden: 'hidden',
      visible: 'visible',
    },
    shipping: 'fast-delivery',
    slider: {
      arrow: {
        left: 'arrow-left',
        right: 'arrow-right',
      },
    },
  },
  installmentPaymentBanner: {
    paypal: {
      enabled: true,
      layout: 'text',
    },
  },
  iubenda: {
    languages: [
      {
        cookiePolicyId: 90435406,
        languageCode: 'it',
      },
    ],
    showPrivacyPolicy: false,
    siteId: '4272754',
    useWidget: true,
    widgetId: '52dabdfc-9e0a-4a55-8ebd-da381640228b',
  },
  paypal: {
    merchantClientId: 'AS-zz8zfHI-6-jFIsCMZd2J5R_jO4U9qywhakSJWGiDVuFhlWwgB1UKv1lRSdg0k25CXwt481-mbbp1y',
  },
  preRelease: true,
  preselectFirstAvailableSku: true,
  productImageAspectRatio: 6 / 7,
  projectName: 'Yes Zee',
  showSkipLinksFooter: true,
  showSkipLinksMain: true,
  ui: 'bs5',
  variants: {
    AccountHomePage: 'A',
    AccountOffcanvas: 'A',
    AccountReferralSubpage: 'A',
    AddressFieldset: 'A',
    Button: Button,
    CartAddressFromAddressBookForm: 'A',
    CartAddressesForm: 'A',
    CartPage: 'B',
    CartSku: CartSku,
    ChangePasswordForm: 'A',
    Container: Container,
    CustomerAddressForm: 'A',
    CustomerForm: 'B',
    InvoiceFieldset: 'A',
    LoginForm: 'A',
    ProductStickyFooter: 'E',
    ProductTile: ProductTile,
    ProductTileBasicInfo: ProductTileBasicInfo,
    ProductTileExtraInfo: ProductTileExtraInfo,
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <b2x.router.BrowserRouter>
      <b2x.ModalsContext>
        <App />
      </b2x.ModalsContext>
    </b2x.router.BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
